import { DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material/material.module';

import { HomeComponent } from './home/home.component';

import { StepsComponent } from './steps/steps.component';
import { CervedComponent, DatiAnagraficiComponent, EventiNegativiComponent } from './steps/dati-anagrafici/dati-anagrafici.component';
import { PagamentoFatturazioneComponent } from './steps/pagamento-fatturazione/pagamento-fatturazione.component';
import { DatiFornituraComponent } from './steps/dati-fornitura/dati-fornitura.component';
import { FirmaSottoscrizioneComponent } from './steps/firma-sottoscrizione/firma-sottoscrizione.component';
import { MatNativeDateModule, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { FlexLayoutModule } from '@angular/flex-layout';
import { IndirizzoComponent } from './indirizzo/indirizzo.component';
import { HttpClientModule } from '@angular/common/http';
import { ComponentsModule } from './shared/components/components.module';
import { LoaderComponent } from './loader/loader.component';
import { LoadingComponent } from './shared/loading.service';
import { ErrorPageComponent } from './error-page/error-page.component';
import { ConfirmDialogComponent } from './shared/dialog/confirm-dialog.component';
import { DialogService } from './shared/dialog/dialog.service';
// import { InputDirective, MatErrorComponent } from './shared/input.directive';
import localeIt from '@angular/common/locales/it';
import { registerLocaleData } from '@angular/common';
registerLocaleData(localeIt);

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    StepsComponent,
    DatiAnagraficiComponent,
    PagamentoFatturazioneComponent,
    DatiFornituraComponent,
    FirmaSottoscrizioneComponent,
    IndirizzoComponent,
    LoaderComponent,
    LoadingComponent,
    ErrorPageComponent,
    ConfirmDialogComponent,
    CervedComponent,
    EventiNegativiComponent
    // MatErrorComponent,
    // InputDirective
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FlexLayoutModule,
    BrowserAnimationsModule,
    MaterialModule,
    ReactiveFormsModule,
    MatNativeDateModule,
    MatMomentDateModule,
    HttpClientModule,
    ComponentsModule,
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'it' },
    {
      provide: LOCALE_ID,
      useValue: 'it',
    },
    {
      provide: DEFAULT_CURRENCY_CODE,
      useValue: 'EUR',
    },
    {
      provide: MAT_DATE_FORMATS, useValue: {
        parse: {
          dateOutput: 'DD/MM/YYYY',
          dateInput: 'DD/MM/YYYY',
        },
        display: {
          dateInput: 'DD/MM/YYYY',
          monthYearLabel: 'MMMM YYYY',
          dateA11yLabel: 'LL',
          monthYearA11yLabel: 'MMMM YYYY',
          
        }
      }
    },
    IndirizzoComponent,
    DatiAnagraficiComponent,
    DialogService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
